import React, { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import "./styles.css";
import WithFetchContracts from "../WithFetchContracts/index";
import Icon from "@fortawesome/react-fontawesome";
import { faPlus, faEdit } from "@fortawesome/fontawesome-free-solid";
import { objectToQueryString } from "../../helpers";
import SearchContractFrom from "../../components/SearchContractForm";
import { connect } from "react-redux";
import {
  compose,
  withHandlers,
  setDisplayName,
  branch,
  renderNothing,
  withProps
} from "recompose";
import { actions } from "../../modules/contracts";
import Table from "../../components/Table";
import _, { isEmpty } from "lodash";
import qs from "qs";
import { ContractListItem } from "../../components/ContractList";
import useTitleSetter from "../../components/useTitleSetter";
import useResizeListener from "../../components/useResizeListener";
import {
  getPendingContractsAmount,
  getWaitingForPickupContractsAmount,
  get30DaysRevenue,
  fetchDealer
} from "../../modules/dealers";
import { formatMoney } from "accounting";

const initialValues = {
  tracking_number: "",
  from_date: "",
  to_date: "",
  customer: "",
  aasm_state: ""
};

const SearchForm = compose(
  setDisplayName("SearchForm"),
  connect(
    state => ({
      role: state.settings.role,
      currentDealer: state.dealers.currentDealer,
      submitting: state.contracts.fetchingContracts,
      failFetchContracts: state.contracts.failFetchContracts,
      currentPage: state.contracts.currentPage,
      totalPages: state.contracts.totalPages,
      perPage: state.contracts.perPage
    }),
    {
      fetchContracts: actions.fetchContracts,
      setCurrentPage: actions.setCurrentPage,
      setPerPage: actions.setPerPage,
      setSearchSnapshot: actions.setSearchSnapshot
    }
  ),
  branch(({ role }) => role !== "staff", renderNothing),
  withHandlers({
    onSubmit: ({
      fetchContracts,
      role,
      currentDealer,
      setCurrentPage,
      perPage,
      setSearchSnapshot
    }) => data => {
      if (role === "staff") {
        setCurrentPage(1);
        setSearchSnapshot(data);
        fetchContracts({
          dealer_id: currentDealer.id,
          query_string: objectToQueryString(
            Object.assign({}, data, { page: 1, per_page: perPage })
          )
        });
      }
    },
    onPageChange: ({
      fetchContracts,
      currentDealer,
      role,
      setCurrentPage,
      perPage
    }) => data => page => {
      if (role === "staff") {
        setCurrentPage(page);
        fetchContracts({
          dealer_id: currentDealer.id,
          query_string: objectToQueryString(
            Object.assign({}, data, { page, per_page: perPage })
          )
        });
      }
    },
    onChangePerPage: ({
      fetchContracts,
      currentDealer,
      role,
      setPerPage
    }) => data => ev => {
      if (role === "staff") {
        setPerPage(ev.target.value);
        fetchContracts({
          dealer_id: currentDealer.id,
          query_string: objectToQueryString(
            Object.assign({}, data, { page: 1, per_page: ev.target.value })
          )
        });
      }
    }
  }),
  withProps(({ role }) => ({
    showPagination: role === "staff",
    initialValues
  }))
)(SearchContractFrom);

// const addContractShopingCart = ({
//   jwt,
//   tracking_number,
//   dealer_id,
//   customer_id
// }) => {
//   return addContractShoppingCartRequest({
//     jwt,
//     dealer_id: dealer_id,
//     customer_id: customer_id,
//     tracking_number: tracking_number
//   });
// };

const renderDetailsLink = ({
  role,
  fetchCustomerContracts,
  user: { jwt }
}) => ({ value }) => (
  <Fragment>
    {console.log("value: ", value)}
    <div className="row m-0">
      {role === "staff" && (
        <div className="col-12 p-0 mb-3">
          <Link className="" to={`/contracts/${value.tracking_number}/edit`}>
            Edit <Icon icon={faEdit} />
          </Link>
        </div>
      )}

      {role === "customer" && (
        <div className="col-12 px-0 pt-3 mb-3">
          <Link to={`/contracts/${value.tracking_number}/tracking`}>
            View tracker <Icon icon="history" />
          </Link>
        </div>
      )}

      <div className="col-12 p-0 mb-3">
        <Link to={`/contracts/${value.tracking_number}`}>
          View details <Icon icon="list-alt" />
        </Link>
      </div>

      {role === "staff" && (
        <div className="col-12 p-0 mb-3">
          Queue # {value.queue_position}
        </div>
      )}
      {/* {role === "customer" && (
        <Fragment>
          <div className="col-12 mb-3">
            <button
              className="button__actions"
              onClick={async () => {
                await addContractShopingCart({
                  jwt,
                  tracking_number: value.tracking_number,
                  dealer_id: value.dealer.id,
                  customer_id: value.customer.id
                });
                await window.confirm("Item added to shopping cart");
                fetchCustomerContracts({
                  dealer_id: value.dealer.id,
                  customer_id: value.customer.id
                });
              }}
            >
              Add <Icon icon="shopping-cart" />
            </button>
            <AddToCartSuccessAdvice />
          </div>
        </Fragment>
      )} */}
    </div>
  </Fragment>
);

const mobileColumns = props => {
  const { role, history } = props;
  const simpleAccessor = contract => contract;
  const renderContract = ({ value }) => {
    return (
      <div
        className="selectable"
        style={{ overflowX: "scroll" }}
        onClick={() => {
          history.push(`/contracts/${value.tracking_number}`);
        }}
      >
        <ContractListItem role={role} contract={value} />
      </div>
    );
  };
  return [
    {
      Header: "Contract",
      id: "contract",
      accessor: simpleAccessor,
      Cell: renderContract,
      className: "tdcell"
    },
    {
      Header: "Actions",
      id: "details",
      accessor: simpleAccessor,
      Cell: renderDetailsLink(props),
      width: 150,
      className: "tdcell"
    }
  ];
};

const customerColumns = props => {
  const { role } = props;
  const simpleAccessor = contract => contract;
  const renderContract = ({ value }) => {
    return (
      <div className="selectable">
        <ContractListItem role={role} contract={value} />
      </div>
    );
  };
  return [
    {
      Header: "Contract Info",
      id: "contract",
      accessor: simpleAccessor,
      Cell: renderContract,
      className: "tdcell"
    }
  ];
};

const ContractsTable = compose(
  setDisplayName("ContractsTable"),
  WithFetchContracts,
  withHandlers({
    onPageChange: ({
      fetchContracts,
      currentDealer,
      searchSnapshot,
      perPage,
      setCurrentPage
    }) => index => {
      const page = index + 1;
      fetchContracts({
        dealer_id: _.get(currentDealer, "id", ""),
        query_string: qs.stringify(
          { page, per_page: perPage, ...searchSnapshot },
          { addQueryPrefix: true }
        )
      }).then(() => {
        setCurrentPage(page);
      });
    },
    onPageSizeChange: ({
      fetchContracts,
      currentDealer,
      searchSnapshot,
      setPerPage
    }) => pageSize => {
      fetchContracts({
        dealer_id: _.get(currentDealer, "id", ""),
        query_string: qs.stringify(
          { page: 1, per_page: pageSize, ...searchSnapshot },
          { addQueryPrefix: true }
        )
      }).then(() => {
        setPerPage(pageSize);
      });
    }
  })
)(props => {
  const {
    contracts,
    perPage,
    onPageChange,
    onPageSizeChange,
    totalPages,
    currentPage,
    role,
    auth
  } = props;
  const isStaff = role === "staff";
  const user = _.get(auth, "user", {});
  let final_contracts =
    role === "contact"
      ? isEmpty(contracts)
        ? user.contact_for
        : contracts
      : isEmpty(contracts)
      ? []
      : contracts;
  return (
    <Table
      manual
      page={currentPage - 1}
      pages={totalPages}
      pageSize={perPage}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      noDataText={"No contracts available"}
      data={final_contracts}
      columns={isStaff ? mobileColumns(props) : customerColumns(props)}
      className="contracts-table -striped"
      style={{
        height: "100%", // This will force the table body to overflow and scroll, since there is not enough room
        marginBottom: "50px"
      }}
    />
  );
});

const withRoleState = connect(state => ({ role: state.settings.role }));

const justForStaff = compose(
  withRoleState,
  branch(({ role }) => role !== "staff", renderNothing)
);

const CreateContractLink = compose(
  setDisplayName("CreateContractLink"),
  justForStaff
)(() => (
  <div className="col-auto mb-3 mb-lg-0">
    <Link to={`/contracts/new`} className="btn btn-primary btn-fill">
      Create Contract <Icon icon={faPlus} />
    </Link>
  </div>
));

const Contracts = compose(
  setDisplayName("Contracts"),
  connect(
    state => ({
      pendingContracts: getPendingContractsAmount(state),
      waitingForPickup: getWaitingForPickupContractsAmount(state),
      revenue30Days: get30DaysRevenue(state),
      auth: state.auth
    }),
    {
      fetchDealer: fetchDealer
    }
  )
)(props => {
  const {
    currentDealer,
    fetchDealer,
    role,
    pendingContracts,
    waitingForPickup,
    revenue30Days
  } = props;
  useTitleSetter("Contracts");
  const width = useResizeListener();
  const isStaff = role === "staff";
  const dealerId = _.get(currentDealer, "id", "");

  useEffect(() => {
    if (dealerId) {
      fetchDealer(dealerId);
    }
  }, [dealerId, fetchDealer]);
  return (
    <div className="row">
      <div className="col-lg-9 mb-3 order-lg-1 order-2">
        {isStaff && (
          <Fragment>
            <div className="row justify-content-between align-items-center">
              <div className="col-auto">
                <h3>
                  <b>Search Contracts</b>
                </h3>
              </div>
              <CreateContractLink {...props} />
            </div>
            <div className="row mb-3">
              <div className="col">
                <div className="card">
                  <div className="content">
                    <SearchForm {...props} />
                  </div>
                </div>
              </div>
            </div>
          </Fragment>
        )}
        {width >= 992 && (
          <div className="row justify-content-between align-items-end">
            <div className="col-auto">
              <h3>
                <b>Contracts</b>
              </h3>
            </div>
            <div className="col-auto">
              <h4 className="mb-3">
                <Icon icon="star" /> For express contracts
              </h4>
            </div>
          </div>
        )}
        <ContractsTable {...props} />
      </div>
      {isStaff && (
        <div className="col-lg-3 order-lg-2 order-1">
          <div className="row row-eq-height">
            <div className="col-lg-12 col-sm-4 mb-3">
              <div className="card" style={{ height: "100%" }}>
                <div className="content">
                  <h5 className="text-center">
                    <b>PENDING CONTRACTS</b>
                  </h5>
                  <h3 className="text-center align-bottom">
                    <b>{pendingContracts}</b>
                  </h3>
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-sm-4 mb-3">
              <div className="card" style={{ height: "100%" }}>
                <div className="content">
                  <h5 className="text-center">
                    <b>SCOOTERS WAITING TO BE PICKED UP</b>
                  </h5>
                  <h3 className="text-center">
                    <b>{waitingForPickup}</b>
                  </h3>
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-sm-4 mb-3">
              <div className="card" style={{ height: "100%" }}>
                <div className="content">
                  <h5 className="text-center">
                    <b>SERVICE REVENUE IN THE LAST 30 DAYS</b>
                  </h5>
                  <div className="total text-center">
                    <h3 className="my-0">
                      <b>{formatMoney(revenue30Days)}</b>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
});

export default Contracts;
